import './_services-deleted.header.scss'
import React, { useContext, useMemo } from 'react';
import { Grid, Button } from 'react-bootstrap';

import { useHistory } from 'react-router-dom';
import SearchInput from '../../../../../components/Search/SearchInput';
import { ServicesDeletedContext } from '../../index';
import { changeQuery, changeSearchType } from '../../reducer';

export const getSearchOptions = (searchTypes) => {
  if (searchTypes?.length) {
    const options = searchTypes.map((searchType) => ({
      value: searchType.id,
      name: searchType.title,
    }));
    return [
      {
        value: null,
        name: 'All',
      },
      ...options,
    ]
  }
  return []
}

const ServicesDeletedHeader = () => {
  const [store, dispatch] = useContext(ServicesDeletedContext);
  const { filters, search_type } = store;
  const searchOptions = useMemo(() => getSearchOptions(search_type), [search_type])
  const history = useHistory();

  const onChangeSearch = (e) => {
    const value = e.target.value;
    dispatch(changeQuery(value))
  };

  const onChangeSearchOption = (e) => {
    const value = (e.target.value).toLowerCase() === 'all' ? null : e.target.value;
    dispatch(changeSearchType(value))
  };

  const onClickBack = () => {
    history.push('/services');
  }

  return (
    <Grid fluid>
      <ul className="nav nav-tabs services-header">
        <li className="services-header__item">
          <Button
            onClick={onClickBack}
            bsStyle="link"
            type="button"
          >
            <span className="services-deleted__back">‹</span>
            Back to services
          </Button>
        </li>
        <li className="pull-right">
          <SearchInput
            onChange={onChangeSearch}
            onChangeOption={onChangeSearchOption}
            value={filters.query ? filters.query : ''}
            optionSelected={filters.search_type}
            placeholder="Search"
            options={searchOptions}
          />
        </li>
      </ul>
    </Grid>
  );
};

ServicesDeletedHeader.propTypes = {

};

export default ServicesDeletedHeader;
